module.exports = __webpack_public_path__ + "img/ico-linkedin.8371e5a4.svg";